<script setup lang="ts">
import {inject, ref} from "vue";
import {RouterLink, useRouter} from "vue-router";
import {useConfirm} from "primevue/useconfirm";
import {deleteStimulus, getStimulus as apiGetStimulus} from "@/Services/Admin/admin-stimuli";
import {PageHeading, PageLoading} from "@/Components/Global";
import {Avatar, Button, Card, Menu} from "@/Components/Library";
import type dayjs from "dayjs";
import StimulusDisplay from "@/Pages/User/Stimuli/StimulusDisplay.vue";

const $date = inject("date") as typeof dayjs;
const router = useRouter();
const confirm = useConfirm();

const stimulus = ref();
const stimulusMenuContainer = ref<Menu>();
const stimulusMenuItems = [
    // {
    //     label: "Edit",
    //     icon: "pepicons-pencil:dots-y",
    //     command: () => {
    //         router.push({
    //             name: "admin.stimuli.edit",
    //             params: {stimulus: router.currentRoute.value.params.stimulus},
    //         });
    //     },
    // },
    {
        label: "Archive",
        icon: "prime:trash",
        class: "text-red-600 hover:bg-red-100",
        command: () => archiveStimulus(),
    },
];

const getStimulus = async () =>
    apiGetStimulus(router.currentRoute.value.params.stimulus).then((data) => (stimulus.value = data));
getStimulus();

const archiveStimulus = () => {
    confirm.require({
        message: "Are you sure you want to archive this stimulus?",
        accept: async () => {
            await deleteStimulus(stimulus.value.id);
            await router.push({name: "admin.stimuli.index"});
        },
        acceptClass: "bg-red-600 text-white px-2 py-1 rounded-lg hover:brightness-110",
        rejectClass: "px-2 py-1 hover:brightness-110",
    });
};
</script>
<template>
    <div class="mx-auto w-full max-w-5xl">
        <div class="m-container mb-3">
            <PageHeading title="Stimulus">
                <div class="ml-auto flex gap-2">
                    <Button
                        :icon="{
                            icon: 'pepicons-pencil:dots-y',
                            width: '24',
                        }"
                        class="!ring-0"
                        @click.stop="stimulusMenuContainer.menu.toggle($event)"
                    />
                    <Menu ref="stimulusMenuContainer" popup :model="stimulusMenuItems" />
                </div>
            </PageHeading>
        </div>
        <PageLoading v-if="!stimulus" />
        <div v-else class="flex flex-col gap-4">
            <div class="flex flex-col gap-4">
                <div>
                    <h2 class="mb-2 break-words text-2xl font-bold">{{ stimulus.title }}</h2>
                    <StimulusDisplay :stimulus="stimulus" />
                </div>
                <Card class="grow">
                    <template #title>Details</template>
                    <table v-if="stimulus">
                        <tbody>
                            <tr>
                                <td>ID</td>
                                <td>{{ stimulus.id }}</td>
                            </tr>
                            <tr>
                                <td>Data</td>
                                <td>{{ stimulus.data ?? "-" }}</td>
                            </tr>
                            <tr>
                                <td>Owner</td>
                                <td>
                                    <RouterLink
                                        class="grow"
                                        :to="{name: 'admin.users.show', params: {user: stimulus.user.id}}"
                                    >
                                        <div class="flex w-full items-center gap-2 py-1 pr-2">
                                            <div class="flex grow items-center gap-2">
                                                <Avatar
                                                    :user="stimulus.user"
                                                    class="h-10 w-10 shrink-0 !rounded-full"
                                                />
                                                <h3 class="grow font-normal">
                                                    {{ stimulus.user.first_name }}
                                                    <span class="font-bold">{{ stimulus.user.last_name }}</span>
                                                </h3>
                                            </div>
                                        </div>
                                    </RouterLink>
                                </td>
                            </tr>
                            <tr>
                                <td>Created At</td>
                                <td>
                                    {{ $date(stimulus.created_at).format("DD/MM/YYYY HH:mm") }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Card>
                <!--                <Card class="md:w-fit">-->
                <!--                    <template #title>Params</template>-->
                <!--                    <table>-->
                <!--                        <tbody>-->
                <!--                            <template v-for="[key, value] in Object.entries(stimulus.params)" :key="key">-->
                <!--                                <tr>-->
                <!--                                    <td>{{ Str.of(key).title() }}</td>-->
                <!--                                    <td>-->
                <!--                                        <span v-if="typeof value === 'boolean'">-->
                <!--                                            {{ value ? "Yes" : "No" }}-->
                <!--                                        </span>-->
                <!--                                        <span v-else>-->
                <!--                                            {{ value }}-->
                <!--                                        </span>-->
                <!--                                    </td>-->
                <!--                                </tr>-->
                <!--                            </template>-->
                <!--                        </tbody>-->
                <!--                    </table>-->
                <!--                </Card>-->
            </div>
            <!--            <Card>-->
            <!--                <template #title>Tags</template>-->
            <!--                <div v-if="stimulus.tags.length" class="flex flex-wrap gap-2 pt-2">-->
            <!--                    <Tag v-for="tag in stimulus.tags" :key="tag.id" :value="tag.name" />-->
            <!--                </div>-->
            <!--                <div v-else class="p-2 text-center">No tags attached.</div>-->
            <!--            </Card>-->
            <!--            <Card v-if="stimulus.options.length">-->
            <!--                <template #title>Options</template>-->
            <!--                <PerfectScrollbar class="flex max-h-96 flex-col divide-y overflow-y-scroll">-->
            <!--                    <template v-for="(option, i) in stimulus.options" :key="option.id">-->
            <!--                        <div class="relative flex w-full transition-colors duration-300 hover:bg-stone-50">-->
            <!--                            <div class="flex w-full items-center gap-2 py-1 pr-2">-->
            <!--                                <div class="flex grow items-center gap-2">-->
            <!--                                    <div class="h-6 w-6 rounded-full bg-askr-green text-center text-white">-->
            <!--                                        {{ i + 1 }}-->
            <!--                                    </div>-->
            <!--                                    <h3 class="grow font-normal">{{ Str.of(option.value).title() }}</h3>-->
            <!--                                </div>-->
            <!--                                <div>-->
            <!--                                    &lt;!&ndash; TODO: Responses count &ndash;&gt;-->
            <!--                                </div>-->
            <!--                            </div>-->
            <!--                        </div>-->
            <!--                    </template>-->
            <!--                </PerfectScrollbar>-->
            <!--            </Card>-->
        </div>
    </div>
</template>
<style scoped>
td {
    @apply py-1.5 pr-8 align-top;
}

tr > td:first-child {
    @apply font-bold;
}
</style>
